import { render, staticRenderFns } from "./MaterielGeneral.vue?vue&type=template&id=63bf1c62&scoped=true&"
import script from "./MaterielGeneral.vue?vue&type=script&lang=js&"
export * from "./MaterielGeneral.vue?vue&type=script&lang=js&"
import style0 from "./MaterielGeneral.vue?vue&type=style&index=0&id=63bf1c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf1c62",
  null
  
)

export default component.exports